import React, { useEffect, useState } from "react";
import { debounce } from "lodash";
import { useTranslation } from "react-i18next";
import { useNavigate, withRouter } from "react-router";
import { Loading } from "../Loading";
import axiosInstance from "../../../axios";
import { buildCourseDetailsURI, formatString } from "../../../_helpers";
import { getS3URL } from "../../../_helpers";
import "./search.scss";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const slugify = (text) => {
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\w\-]+/g, "")
    .replace(/\-\-+/g, "-")
    .replace(/^-+/, "")
    .replace(/-+$/, "");
};

const Search = ({ history, variant }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [filter, setFilter] = useState();
  const { loggedIn } = useSelector((state) => state.authentication);
  const { categories, isLoading, error } = useSelector(state => state?.category);
  const { REACT_APP_LOGIN_API_BASEURL } = process.env;
  const [query, setQuery] = useState("");
  const [inputValue, setInputValue] = useState(null);
  const [values, setValue] = useState(null);
  const [suggestions, setSuggestions] = useState([]);
  const [showAutoComplete, setShowAutocomplete] = useState(false);
  const [categorie, setcategories] = useState([]);
  
  

  const fetchSuggestions = async (value, type) => {
    try {
      setQuery(value);
      if (value.length > 2) {
        setShowAutocomplete(true);
        const data = {
          category: "",
          subCategory: "",
          level: "",
          search: value,
        };
        const { data: response } = await axiosInstance.post(
          `${REACT_APP_LOGIN_API_BASEURL}/v1/course`,
          data
        );

        const courses = response?.data?.courses;
        setcategories(courses);
        setSuggestions(
          courses?.length > 0 ? courses : [{ name: "No Records Found" }]
        );
      } else {
        setShowAutocomplete(false);
      }
    } catch (error) {
      console.error("Error fetching suggestions:", error);
      toast.error("Failed to fetch course suggestions");
      setSuggestions([{ name: "Error fetching suggestions" }]);
    }
  };

 

  const handleFocus = (suggestions) => {
    if (suggestions.length > 0 && query.length > 3) {
      setShowAutocomplete(true);
    }
  };

  const handleChangeDebounce = debounce((value) => {
    setValue(value);
    fetchSuggestions(value, variant);
  }, 500);

  useEffect(() => {
    return () => handleChangeDebounce.cancel();
  }, []);

 

  useEffect(() => {
    const handleClick = (event) => {
      const searchInput = document.getElementById("course-search");
      const autoComplete = document.getElementById("auto-complete");
      if (searchInput && autoComplete) {
        const isClickInside = searchInput.contains(event.target)
          ? true
          : autoComplete.contains(event.target)
            ? false
            : false;

        if (!isClickInside) {
          setShowAutocomplete(false);
        } else {
          setInputValue(null);
        }
      }
    };
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);

  const handleFormSubmit = (event, query) => {
    try {
      event.preventDefault();
      setFilter({
        fliterCategory: inputValue,
        fliterLevel: null,
      });

      if (values) {
        //console.log("values", values);
        navigate(`/search-new?new-item-type=${encodeURIComponent(values)}`);
      } else {
        toast.warn("Please enter a valid search term");
      }

      setShowAutocomplete(false);
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Search submission failed");
    }
  };

  return (
    <>
      <div className="relative">
        <form
          id="contact-form"
          onSubmit={(event) => handleFormSubmit(event, query)}
          className=" w-full max-w-2xl mx-auto"
        >
          <div className="w-[90%] ml-3 flex items-center bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md px-2 shadow-md transition focus-within:ring-2 focus-within:ring-blue-500">
            <input
              id="course-search"
              type="text"
              name="inputValue"
              value={inputValue}
              placeholder={t("Search for courses")}
              className="flex-grow !border-none bg-transparent text-gray-800 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none text-sm md:text-base"
              aria-label="Search"
              autoComplete="off"
              onChange={(event) => handleChangeDebounce(event.target.value)}
              onFocus={() => handleFocus(suggestions)}
              required
            />
            <button
              type="submit"
              aria-label="Search"
              className="ml-3 p-2 text-white bg-white-600 hover:bg-white-700  transition duration-200 "
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-7 w-7  text-gray-900 p-1"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M21 21l-4.35-4.35M16 10a6 6 0 11-12 0 6 6 0 0112 0z"
                />
              </svg>
            </button>
          </div>
        </form>
      </div>
      <div className="!absolute w-[400px]">
        <AutoComplete
          isActive={showAutoComplete}
          dispatch={dispatch}
          query={query}
          categoryData={categories}
          history={history}
          input={inputValue}
          setFilter={setFilter}
          suggestions={suggestions}
          categories={categorie}
          setInputValue={setInputValue}
          showSuggestions={setShowAutocomplete}
        />
      </div>
    </>
  );
};

export const SearchBar = Search;

const AutoComplete = ({
  isActive,
  query,
  suggestions,
  history,
  categoryData,
  dispatch,
  setFilter,
  input,
  categorie,
  setInputValue,
}) => {
  const navigate = useNavigate();
  const { loggedIn } = useSelector((state) => state.authentication);

  const handleViewProgram = (suggestion) => {
    try {
      const slug = slugify(suggestion.CourseName);
      const id = suggestion.ID;

      // navigate(`/${slug}/${id}`, { state: { course: suggestion } });
      navigate(`/${slug}`, { state: { course: suggestion } });
    } catch (error) {
      console.error("Error navigating to course:", error);
      toast.error("Failed to open course details");
    }
  };

  const getHighlightedText = (text, highlight) => {
    const parts = text?.split(new RegExp(`(${highlight})`, "gi"));
    return (
      <span>
        {parts?.map((part, index) =>
          part?.toLowerCase() === highlight?.toLowerCase() ? (
            <mark key={index} className="bg-blue-100 text-blue-800 px-1 rounded">
              {part}
            </mark>
          ) : (
            part
          )
        )}
      </span>
    );
  };

  return isActive ? (
    <div
      id="auto-complete"
      className="z-50 mt-2 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl shadow-2xl max-h-[400px] overflow-y-auto animate-fadeIn transition-all duration-300"
    >
      {suggestions?.length > 0 && suggestions[0]?.CourseName ? (
        <div className="divide-y divide-gray-200 dark:divide-gray-700">
          {suggestions.map((suggestion, index) => (
            <div
              key={index}
              className="group p-4 hover:bg-gray-100 dark:hover:bg-gray-800 transition duration-200"
            >
              <button
                onClick={() => handleViewProgram(suggestion)}
                className="flex items-center gap-4 w-full text-left transform transition-transform duration-300 group-hover:scale-[1.02]"
              >
                {suggestion?.imageFiles?.fileName && (
                  <div className="w-16 h-16 overflow-hidden rounded-md border border-gray-300 bg-gray-100">
                    <img
                      src={getS3URL(suggestion.imageFiles.fileName)}
                      alt={suggestion.CourseName}
                      className="object-cover w-full h-full"
                      loading="lazy"
                    />
                  </div>
                )}
                <div className="flex-1">
                  <h3 className="text-sm md:text-base font-semibold text-gray-900 dark:text-white">
                    {getHighlightedText(suggestion.CourseName, query)}
                  </h3>
                  {suggestion?.EnrollmentFee && (
                    <p className="text-xs text-green-600 mt-1">
                      ₹{suggestion.EnrollmentFee}
                    </p>
                  )}
                  {suggestion?.description && (
                    <p
                      className="text-sm text-gray-600 dark:text-gray-400 mt-1 line-clamp-2"
                      dangerouslySetInnerHTML={{
                        __html:
                          suggestion.description.substring(0, 150) + "...",
                      }}
                    />
                  )}
                </div>
              </button>
            </div>
          ))}
        </div>
      ) : (
        <div className="p-4 text-center text-gray-500 dark:text-gray-400">
          No results found
        </div>
      )}
    </div>
  ) : null;
};
